<template>
  <div>

     <data-table
        table-ref="progress-table"

        :title="permitLabel"
        icon="fa fa-share-alt"

        :hide-org-badge="hideBadge"
        :show-search="showSearch"

        :url="'/actions/site/' + rowData.id + '/null/prg'"

        :fields="fields"

        detail-component="progress-detail-row" />
<!--
        :add-action="isManager('project|maintenance|finance|property|admin') ? action : null"
        :add-props="addProps"
-->
  </div>

</template>


<script>
import Vue from 'vue'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import ProgressAction from '@/components/actions/ProgressAction'

import ProgressWorkflow from '@/components/progress/ProgressWorkflow'
import ProgressControls from '@/components/progress/ProgressControls'

import {settings} from '@/components/Data'

Vue.component('progress-detail-row', ProgressWorkflow)
Vue.component('progress-controls', ProgressControls)

export default {

  mixins: [DateMixins, NumberMixins],


  components: {
    ProgressAction,
    ProgressWorkflow
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    hideBadge: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }


  },



  data () {

    return {

      telcoId: this.isTelco() ? Number(this.org().id) : null,
      permitLabel: settings.permitLabel,

/*
      action: ProgressAction,

      addProps: {
        rowData: [],
        editMode: true,
        readOnly: this.readOnly,
        siteId: this.rowData.id
      },
*/
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'actionType',
          title: 'Type',
          sortField: 'actionType',
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'priority',
          title: 'Priority',
          sortField: 'priority',
          callback: this.formatPriority,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'organisation.shortName',
          title: 'Company',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'targetDate',
          title: 'Target Date',
          callback: 'formatDate|DD MMM YYYY',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: '__component:progress-controls',
          title: ''
        }

      ]
    }

  }

}

</script>



// WEBPACK FOOTER //
// SiteProgress.vue?14dd790c